import {TranslatePipe} from '@ngx-translate/core';
import {Component, Input, OnInit} from '@angular/core';
import {FormComponent} from '@app/common/ui-kits/form/form.component';

@Component({
  selector: 'app-book-online-section',
  templateUrl: './book-online-section.component.html',
  styleUrls: ['./book-online-section.component.scss'],
  imports: [
    FormComponent,
    TranslatePipe
  ]
})
export class BookOnlineSectionComponent implements OnInit {
  public showForm = false;
  @Input() tourId: string | null = null;
  @Input() toursId: string[] = [];

  constructor() {
  }

  ngOnInit(): void {
  }

}
